import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-add-services',
  templateUrl: './add-services.component.html',
  styleUrls: ['./add-services.component.css']
})
export class AddServicesComponent {
  checkboxError = false;
  form: FormGroup;
  roads = ["National Highways (NH)", "State Highways (SH)", "District Roads (MDR)", "Village Roads (VR)"]
  roadsT = ["New Road",
    "Tree cover",
    "Parking bays",
    "Toll Plaza construction",
    "Footpath construction",
    "Amenities Construction",
    "Shopping Mall Construction",
    "New Drainage",
    "Maintenance - Road",
    "Maintenance - Parking bays",
    "Maintenance - Tree",
    "Maintenance - Toll Plaza",
    "Maintenance - Amenities",
    "Maintenance - shopping Mall",
    "Maintenance - Drainage",];

  constructor(private fb: FormBuilder) {
    // const defaultCities = ["New Road"];
    // this.form = this.formBuilder.group({
    //   roadsT: this.formBuilder.array(
    //     this.roadsT.map(x => defaultCities.indexOf(x) > -1)
    //   ),

    // });
    this.form = this.fb.group({
      userType: ['', Validators.required],
      roadsT: this.fb.array(this.roadsT.map(() => this.fb.control(false)))
    });
  
  }

  convertToValue(key: string) {
    // return this.form.value[key]
    //   .map((x, i) => x && this[key][i])
    //   .filter(x => !!x);
  }

  // onSubmit() {
  //   const valueToStore = Object.assign({}, this.form.value, {
  //     roads: this.convertToValue("roads"),
  //   });
  //   console.log(valueToStore);
  // }
  onSubmit() {
    const selectedRoads = this.form.value.roadsT
      .map((checked: boolean, i: number) => checked ? this.roadsT[i] : null)
      .filter((v: string | null) => v !== null);
  
    this.checkboxError = selectedRoads.length === 0;
  
    if (this.form.invalid || this.checkboxError) {
      this.form.markAllAsTouched();
      return;
    }
  
    console.log('Form submitted:', {
      userType: this.form.value.userType,
      selectedRoads
    });
  }
}
